export { default as NextLinkCard } from './nextLinkCard'



// WEBPACK FOOTER //
// ./src/components/card/nextLinkCard/index.js